import axios from 'axios'
import {ref} from 'vue'

const previousConferencesURL = 'api/previous-conferences'
const backEndURL = process.env.VUE_APP_BACKEND_URL

/**
 * Input example: conference = { year: null }
 * Output example: null
 */
export const getPreviousConferenceYear = conference => {
    const conferenceYear = Number(conference?.year)

    return Number.isInteger(conferenceYear) && conferenceYear > 0
        ? conferenceYear
        : null
}

export const usePreviousConference = () => {
    const previousConference = ref(null)
    const loading = ref(false)
    const error = ref(null)

    const resetState = () => {
        previousConference.value = null
        error.value = null
    }

    // Input example: fetchPreviousConferenceByYear("2024")
    // Output example: previousConference.value = { id: 3, date: "2024", photos: [], videos: [], sponsors: [] }
    const fetchPreviousConferenceByYear = async yearParam => {
        resetState()
        loading.value = true

        const requestedYear = Number(yearParam)

        if (!Number.isInteger(requestedYear) || requestedYear < 1) {
            error.value = 'Invalid previous conference year.'
            loading.value = false
            return null
        }

        try {
            const response = await axios.get(`${backEndURL}/${previousConferencesURL}`)
            const conferences = Array.isArray(response.data) ? response.data : []
            const conference = conferences.find(item => getPreviousConferenceYear(item) === requestedYear) ?? null

            if (!conference) {
                error.value = 'Previous conference not found.'
                return null
            }

            previousConference.value = conference
            return conference
        } catch (requestError) {
            console.error(requestError)
            error.value = 'Failed to load previous conference.'
            return null
        } finally {
            loading.value = false
        }
    }

    return {
        previousConference,
        loading,
        error,
        fetchPreviousConferenceByYear,
    }
}
